import { render, staticRenderFns } from "./classrecordDetail.vue?vue&type=template&id=aad37216&"
import script from "./classrecordDetail.vue?vue&type=script&lang=js&"
export * from "./classrecordDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports